/**
 * OverviewPage — route entry for the Admin Operational Overview dashboard
 * (ODE-P07-T01). Applies the client-side permission mirror (UX only — the
 * server-side guard on both overview endpoints remains the authority) and
 * renders the dashboard component. Test seams are passed through to the
 * dashboard (no real fetch/socket in tests).
 *
 * Traces to: ODE-PRD-REQ-043, ODE-PRD-REQ-044, ODE-PRD-REQ-048,
 *            ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import { OverviewDashboard, type OverviewDashboardSeams } from './OverviewDashboard.js';

export function OverviewPage({
  seams,
}: {
  readonly seams?: OverviewDashboardSeams;
} = {}): JSX.Element {
  const { session } = useAuth();
  const allowed =
    session !== null && hasPermission(session.staff.roles, 'dashboard.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin dashboard.view untuk halaman ini.',
        }}
      />
    );
  }
  return <OverviewDashboard seams={seams ?? {}} />;
}
